import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { Nav as BSNav } from "react-bootstrap";
import Logo from "assets/SimpliCapital-logo.png";
import CollapsedLogo from "assets/logo.png";
import {
  Forecast,
  NetCashIcon,
  OrdersIcon,
  ScenarioIcon,
  SettingIcon,
  ReceivablesIcon,
  ArrowExpandIcon,
  TopArrowSubmenuIcon,
  TransactionIcon,
  Cros,
} from "assets/icons.js";
import { Link } from "react-router-dom";
import { QuickBookConnectionContext } from "context/QuickBookConnectionContext";
import { Route_URLs } from "routesURLs";
import { forFutureRelease } from "utils/Configs";
import { Authorise } from "helpers/Authorization";
import { useProfile } from "queries/profile";
import { useMyLoyaltyConfig } from "queries/loyalty";

const StyledSidebar = styled.div`
  background: #3a3b48;
  box-shadow: 0px 3px 16px #0000001d;
  position: fixed;
  display: block;
  padding: 20px;
  z-index: 55555;
  height: 100%;
  top: 0;
  transition: all 0.2s ease-in;

  ${({ disableTransitionEffects }) =>
    disableTransitionEffects &&
    `
   transition: none !important;
  `}

  width: ${(props) =>
    props.isMobile
      ? props.mobileSidebarCollapsed
        ? "0"
        : "211px"
      : props.collapsed
        ? "85px"
        : "211px"};
  padding: ${(props) =>
    props.isMobile && props.mobileSidebarCollapsed ? "0" : "20px"};
  overflow: hidden;

  .nav-link.active svg {
    fill: #33c2df;
  }

  .nav-text {
    opacity: ${(props) => (props.collapsed ? "0" : "1")};
    display: ${(props) => (props.collapsed ? "none" : "inline-block")};
    width: ${(props) => (props.collapsed ? "0" : "63%")};
    transition: opacity 0.7s ease-in;
  }

  .toggle-button {
    transform: ${(props) =>
    props.collapsed ? "rotate(0deg)" : "rotate(180deg)"};
    transition: transform 0s;

    svg {
      width: 41px;
      height: 41px;
    }
  }

  .indicator-icon,
  .submenu > div {
    display: ${(props) => (props.collapsed ? "none" : "block")};
  }

  .sub-menu {
    .nav-link {
      display: ${(props) => (props.collapsed ? "none" : "block")};
    }
  }
  .logo {
    display: ${(props) => (props.collapsed ? "none" : "block")};
  }
  .collapsed-logo {
    display: ${(props) => (props.collapsed ? "block" : "none")};
  }

  .indicator-icon {
    opacity: ${(props) => (props.collapsed ? "0" : "1")};
  }
`;

const SidebarShadow = styled(StyledSidebar)`
  position: relative;
  height: 1px;
  z-index: 555;
  top: 0;
  left: 0px;
  background: #3a3b48;
`;

const StyledLogo = styled.div`
  img {
    width: 100%;
  }
  margin-bottom: 36px;
`;
const StyledCollapsedLogo = styled.div`
  img {
    width: auto;
  }
  margin-bottom: 36px;
`;

const Nav = styled(BSNav)`
  flex-direction: column;

  svg {
    margin-right: 10px;
    font-size: 13px;
  }

  a.nav-link {
    text-align: left;
    font-family: Montserrat Alternates-semiBold;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0px;
    color: #ffffff;
    margin-bottom: 1.3rem;
    padding: 0.4rem 1rem;
    margin-left: 10x;
    z-index: 1;
  }
`;

const ExpandIcon = styled.div`
  position: absolute;
  //right: 0;
  //left: 0;
  bottom: 0;
  //text-align: center;
  width: 77%;
  padding: 0;
  margin: 0 auto;
  margin-bottom: 50px;
  z-index: 2;

  .icon {
    cursor: pointer;
    z-index: 2;
    position: absolute;
  }
`;

const SubmenuContent = styled.div`
  padding-left: 8px;
  overflow: hidden;
`;

const SubmenuCaption = styled.div`
  color: #fff;
  font-family: Montserrat Alternates-semiBold;
  font-size: 10px;
  line-height: 13px;
  cursor: pointer;
`;

const StyledSubmenu = styled.div`
  margin-bottom: 0;
  padding: 0.5rem 1rem;
  margin-bottom: 1.5rem;

  .indicator-icon {
    float: right;
    font-size: 1em;
    margin-top: ${(props) => (props.activeLink ? "11px" : "2px")};
    transform: ${(props) => (props.open ? "rotateZ(0deg)" : "rotateZ(90deg)")};
    transition: all 0.2s ease-in-out;
  }

  a.nav-link {
    margin: 0;
    margin-bottom: 0.4rem;
  }

  ${SubmenuContent} {
    transition: all 0.5s ease-in-out;
    margin-top: ${(props) => (props.open ? "12px" : "0")};
    height: ${(props) => (props.open ? "auto" : "0")};
  }
`;

const LockOverlay = styled.div`
  background: transparent;
  cursor: not-allowed;
  width: 100%;
  display: block;
  position: absolute;
  height: 380px;
  z-index: 9999999;
`;
const ActiveLink = styled.span`
  width: 4px;
  height: 20px;
  display: inline-block;
  background-color: #33c2df;
  position: relative;
  left: ${(props) => (props.collapsed ? "65%" : "45%")};
  top: 7px;
`;
const StyledIcon = styled.div`
  display: inline-block;
  svg {
    path {
      fill: ${(props) => (props.active ? "#33C2DF" : "#A5A4BF")};
    }
  }
`;

const CloseButton = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
`;

const Submenu = (props) => {
  const sidebarCollapsed = props.sidebarCollapsed;
  const [open, setOpen] = useState(!sidebarCollapsed);
  const { isQuickbookDataImported } = useContext(QuickBookConnectionContext);

  const toggleMenuOpen = (event) => {
    setOpen(!open);
    event.preventDefault();
    event.stopPropagation();
  };

  const shouldBeOpen = () => {
    if (sidebarCollapsed) {
      return false;
    } else {
      return open;
    }
  };

  useEffect(() => {
    if (isQuickbookDataImported) {
      setOpen(false);
    } else {
      setOpen(JSON.parse(window.sessionStorage.getItem("open" + props.title)));
    }
  }, []);

  useEffect(() => {
    window.sessionStorage.setItem("open" + props.title, open);
  }, [open]);

  return (
    <StyledSubmenu activeLink={props.activeLink} open={shouldBeOpen()}>
      <SubmenuCaption>
        <TopArrowSubmenuIcon className="indicator-icon" />
        <Link to={props.to}>{props.icon}</Link>
        <span className="nav-text" onClick={toggleMenuOpen}>
          {props.title}
        </span>
        {props.activeLink}
      </SubmenuCaption>
      <SubmenuContent>{props.children}</SubmenuContent>
    </StyledSubmenu>
  );
};

function CustomerSidebar(props) {
  const [collapsed, setCollapsed] = useState(true);
  const [disableTransitionEffects, setDisableTransitionEffects] =
    useState(true);

  const toggleSidebar = () => {
    setDisableTransitionEffects(false);
    setCollapsed(!collapsed);
  };

  const { isQuickbookDataImported } = useContext(QuickBookConnectionContext);
  const { data: userData, isLoading } = useProfile();
  const userRole = userData?.role;
  const { data: loyaltyConfigRes } = useMyLoyaltyConfig();
  // const userRole = userData?.role;
  const isLoyaltyEnabled = loyaltyConfigRes?.data?.isEnabled;
  const activeRoute = (routeUrl) => {
    if (routeUrl === window.location.pathname) return true;
    return false;
  };

  useEffect(() => {
    if (isQuickbookDataImported) {
      setCollapsed(true);
    } else {
      setCollapsed(JSON.parse(window.sessionStorage.getItem("collapsed")));
    }
  }, []);

  useEffect(() => {
    window.sessionStorage.setItem("collapsed", collapsed);
  }, [collapsed]);

  /* adding custom logic for disabling all pages if oracle tenant has not integrated oracle connection */

  const handleHomeClick = () => {
    window.location.href = Route_URLs.dashboard_customer;
  };

  return (
    <>
      {isQuickbookDataImported && <LockOverlay />}

      <SidebarShadow
        {...props}
        collapsed={collapsed}
        disableTransitionEffects={disableTransitionEffects}
      />
      <StyledSidebar
        {...props}
        collapsed={props.isMobile ? props.mobileSidebarCollapsed : collapsed}
        disableTransitionEffects={disableTransitionEffects}
      >
        <CloseButton onClick={props.toggleMobileSidebar}>
          <Cros />
        </CloseButton>
        <StyledLogo className="logo">
          <a href={Route_URLs.dashboard_customer}>
            <img alt="SimpliCapital" src={Logo}></img>
          </a>
        </StyledLogo>
        <StyledCollapsedLogo className="collapsed-logo">
          <a href={Route_URLs.dashboard_customer}>
            <img alt="SimpliCapital" src={CollapsedLogo}></img>
          </a>
        </StyledCollapsedLogo>
        <Nav {...props}>
          <Nav.Link onClick={handleHomeClick}>
            <StyledIcon active={activeRoute(Route_URLs.dashboard_customer)}>
              <ScenarioIcon />
            </StyledIcon>
            <span className="nav-text">Home</span>
            {activeRoute(Route_URLs.dashboard_customer) && (
              <ActiveLink collapsed={collapsed} />
            )}
          </Nav.Link>
        </Nav>
        <Nav>
          <Nav.Link as={Link} to={Route_URLs.transactions_customer}>
            <StyledIcon active={activeRoute(Route_URLs.transactions_customer)}>
              {/* <ScenarioIcon /> */}
              <TransactionIcon />
            </StyledIcon>
            <span className="nav-text">Transactions</span>
            {activeRoute(Route_URLs.transactions_customer) && (
              <ActiveLink collapsed={collapsed} />
            )}
          </Nav.Link>
        </Nav>
        {isLoyaltyEnabled && (
          <Nav>
            <Nav.Link as={Link} to={Route_URLs.customer_loyalty}>
              <StyledIcon active={activeRoute(Route_URLs.customer_loyalty)}>
                <Forecast />
              </StyledIcon>
              <span className="nav-text">SimpliRewards</span>
              {activeRoute(Route_URLs.customer_loyalty) && (
                <ActiveLink collapsed={collapsed} />
              )}
            </Nav.Link>
          </Nav>
        )}
        <ExpandIcon className="toggle-button">
          <ArrowExpandIcon
            className="icon"
            onClick={props.isMobile ? props.toggleMobileSidebar : toggleSidebar}
          />
        </ExpandIcon>
      </StyledSidebar>
    </>
  );
}
export default CustomerSidebar;